export function searchInObject(objectToQuery: object, searchQuery: string): boolean {
    return Object.entries(objectToQuery).some(([key, value]) => {
        if (typeof value === 'string') {
            return searchInString(value, searchQuery);
        }

        if (typeof value === 'number') {
            return searchInNumber(value, searchQuery);
        }

        if (value instanceof Date) {
            return searchInDate(value, searchQuery);
        }

        if (isObject(value)) {
            return searchInObject(value, searchQuery);
        }

        return false;
    });
}

export function searchInString(string: string, searchQuery: string): boolean {
    return string.toUpperCase().includes(searchQuery.toUpperCase());
}

function searchInNumber(number: number, searchQuery: string): boolean {
    return number.toString().toUpperCase().includes(searchQuery.toUpperCase());
}

function searchInDate(date: Date, searchQuery: string): boolean {
    return date.toDateString().toUpperCase().search(searchQuery.toUpperCase()) !== -1;
}

function isObject(obj: any): boolean {
    return obj === Object(obj);
}

export function sleep(time: number): Promise<any> {
    return new Promise(resolve => setTimeout(resolve, time));
}
